import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const extractRows = (body) => {
    const level1 = body?.data ?? body;
    const rows = level1?.data ?? level1;
    return Array.isArray(rows) ? rows : [];
};

const IndividualMonitoringService = {
    list: async () => axios.post(`${API_KEEPER}/individual-monitoring/list`, {
        page: 1,
        size: 100000,
        sort: [{field: "name", dir: "asc"}],
        filter: []
    }).then(({data}) => extractRows(data)).catch((err) => { throw err }),

    get: async (id) => axios.get(`${API_KEEPER}/individual-monitoring/${id}`).then(({data}) => data).catch((err) => { throw err }),

    create: async (formData) => axios.post(`${API_KEEPER}/individual-monitoring`, formData).then(({data}) => data).catch((err) => { throw err }),

    update: async (formData) => axios.put(`${API_KEEPER}/individual-monitoring`, formData).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(`${API_KEEPER}/individual-monitoring/${id}`).catch((err) => { throw err }),

    status: async () => axios.get(`${API_KEEPER}/facial-recognition/status`).then(({data}) => data === true || data === "true").catch(() => false),

    getIndividualByCpf: async (cpf) => axios.get(`${API_KEEPER}/individual/${cpf}`).then(({data}) => {
        if (!data) return null;

        const raw = data.data ?? data;
        return typeof raw === "string" ? JSON.parse(raw) : raw;
    }).catch((err) => { throw err }),
};

export default IndividualMonitoringService;
